import HeroSection from "./herosection.jsx";
import { Row, Col, Card, Typography } from "antd";
import { useState, useEffect } from "react";
import settings_4873474 from "../../assets/images/settings_4873474.png";
import sales_icon from "../../assets/images/sales_icon.png";
import chain_16044565 from "../../assets/images/chain_16044565.png";
import online_order from "../../assets/images/online_order.png";
import live_inv from "../../assets/images/live_inv.png";
import invoice from "../../assets/images/invoice.png";

const { Title, Paragraph } = Typography;

const row1Features = [
  {
    title: "Easy to Use & Setup",
    description: "Optix360 is built for speed, simplicity, and zero technical hassle. Whether you're running an optical retail shop or a wholesale business, you can start managing sales, billing, stock, and members instantly — no complex setup or training required. The interface is clean, intuitive, and designed for everyday users in Pakistan, helping you reduce learning curves and get productive from day one.",
    image: settings_4873474
  },
  {
    title: "Online Ordering",
    description: "Expand your business with Optix360’s integrated online ordering system. Allow retailers to place orders directly from their devices—whether it’s for in-store pickup or delivery. Streamline order management with real-time tracking, automated confirmations, and centralized control. It’s the perfect solution for optical shops looking to offer convenience and speed without added complexity. From order placement to fulfillment, Optix360 ensures a smooth and professional customer experience.",
    image: online_order
  },
  {
    title: "Multi-Store Flexibility",
    description: "Whether you're managing retail, wholesale, or a combination of both, Optix360 adjusts seamlessly to your business needs. It supports multiple pricing tiers, customer and members segmentation—making it versatile across industries. From optical retailers and wholesalers shops, Optix360 delivers the flexibility modern businesses require. It's an ideal business solution for shops and wholesale operations that need a system built to grow with them.",
    image: chain_16044565
  },
];

const row2Features = [
  {
    title: "Live Inventory Monitoring",
    description: "Stay on top of your stock in real-time with Optix360’s live inventory monitoring. Instantly track product availability, stock levels, and movement across multiple locations—all from a single dashboard. Get low-stock alerts, avoid overstocking, and make smarter restocking decisions with data-driven insights. Whether you're managing frames, lenses, or accessories, Optix360 ensures your inventory is always accurate and up to date.",
    image: live_inv,
  },
  {
    title: "Sales Analytics & Reports",
    description: "Manage your sales and billing with ease using Optix360.Our powerful sales management system simplifies your day-to-day operations, making it easier to process transactions quickly and accurately.Track income and expenses in real-time, and generate detailed financial reports with just a few clicks.From customer checkouts to invoice generation, every step is designed for efficiency and clarity.Whether you're managing a single store or multiple locations, Optix360 keeps your sales organized and stress-free.",
    image: sales_icon,
  },
  {
    title: "Stock Alerts & Automation",
    description: "Never run out of stock or overstock again with Optix360’s smart stock alerts and automation features. Get real-time notifications when inventory reaches critical levels and automate reordering to save time and reduce manual errors. Whether you’re managing retail, wholesale, or both, Optix360 adapts to your workflows with customizable thresholds and stock rules. Perfect for optical retailers and wholesale shops, it ensures you always have the right products available when you need them.",
    image: chain_16044565
  },
];

const row3Features = [
  {
    title: "Quick Invoice Generation",
    description: "Generate professional invoices within seconds using Optix360’s streamlined billing system. Whether it's a walk-in sale or a wholesale order, you can instantly create, print, and download invoices with accurate product and customer details. Share invoices directly with customers via WhatsApp for added convenience and faster communication. Designed to save time and reduce manual effort, Optix360 helps you maintain a smooth and professional checkout experience every time.",
    image: invoice,
  },
  {
    title: "Product Category Management",
    description: "Easily organize your inventory with Optix360’s flexible product category management system. Create, edit, and manage multiple categories and subcategories for frames, lenses, accessories, and more. This makes it easier to track, search, and filter products quickly—saving time during billing and stock updates. Whether you run a retail store or a wholesale business, Optix360 helps keep your product catalog structured and easy to manage.",
    image: chain_16044565
  },
];

function Features() {
  const [screenSize, setScreenSize] = useState("desktop");

  useEffect(() => {
    document.title = "Features - Optix360";

    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setScreenSize("mobile");
      } else if (window.innerWidth <= 1024) {
        setScreenSize("tablet");
      } else {
        setScreenSize("desktop");
      }
    };

    // Set initial screen size
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getPaddingStyle = () => {
    switch (screenSize) {
      case "mobile":
        return {
          textAlign: "center",
          padding: "30px 15px",
          color: "#000",
          backgroundColor: "#fff",
        };
      case "tablet":
        return {
          textAlign: "center",
          padding: "40px 30px",
          color: "#000",
          backgroundColor: "#fff",
        };
      default:
        return {
          textAlign: "center",
          padding: "50px 110px 80px 110px",
          color: "#000",
          backgroundColor: "#fff",
        };
    }
  };

  const getColumnSpan = () => {
    switch (screenSize) {
      case "mobile":
        return 24;
      case "tablet":
        return 12;
      default:
        return 8;
    }
  };

  const getImageStyle = () => {
    switch (screenSize) {
      case "mobile":
        return { width: "40%", height: "auto", objectFit: "contain", marginBottom: "15px" };
      default:
        return { width: "50%", height: "50%", objectFit: "contain", marginBottom: "20px" };
    }
  };

  const getTitleStyle = () => {
    switch (screenSize) {
      case "mobile":
        return { textAlign: "center", fontSize: "24px", fontWeight: "bold", letterSpacing: "1px", lineHeight: "30px" };
      case "tablet":
        return { textAlign: "center", fontSize: "30px", fontWeight: "bold", letterSpacing: "1px", lineHeight: "38px" };
      default:
        return { textAlign: "center", fontSize: "35px", fontWeight: "bold", letterSpacing: "1px", lineHeight: "45px" };
    }
  };

  const getSubtitleStyle = () => {
    switch (screenSize) {
      case "mobile":
        return { textAlign: "center", fontSize: "14px", fontWeight: "normal", letterSpacing: "0.5px", lineHeight: "20px", color: "rgb(75, 85, 99)", margin: "10px 0 20px 0" };
      case "tablet":
        return { textAlign: "center", fontSize: "15px", fontWeight: "normal", letterSpacing: "0.8px", lineHeight: "22px", color: "rgb(75, 85, 99)", margin: "15px 0 25px 0" };
      default:
        return { textAlign: "center", fontSize: "16px", fontWeight: "normal", letterSpacing: "1px", lineHeight: "25px", color: "rgb(75, 85, 99)", margin: "20px 0 30px 0" };
    }
  };

  const getCardStyle = () => {
    return {
      borderRadius: "16px",
      textAlign: "center",
      height: "100%",
      boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
    };
  };

  return (
    <>
      <HeroSection />
      <div style={getPaddingStyle()}>
        {/* row 1 */}
        <div style={{ marginBottom: "40px", borderBottom: "1px solid #e0e0e0", paddingBottom: "40px" }}>
          <h1 style={getTitleStyle()}>Optix360 – Powerful Features to Streamline Your Business</h1>
          <p style={getSubtitleStyle()}>Discover a suite of intelligent tools designed to help Pakistani Opticals shops grow, operate efficiently, and thrive.</p>

          <Row
            gutter={[16, 24]}
            justify="center"
            style={{
              marginTop: "20px",
              padding: "0 10px",
            }}
          >
            {row1Features.map((feature) => (
              <Col span={getColumnSpan()} key={feature.title}>
                <Card
                  hoverable
                  style={getCardStyle()}
                >
                  <img
                    src={feature.image}
                    alt={feature.title}
                    style={getImageStyle()}
                  />
                  <Title level={screenSize === "mobile" ? 5 : 4}>{feature.title}</Title>
                  <Paragraph type="secondary" style={{ fontSize: screenSize === "mobile" ? "13px" : "14px" }}>
                    {feature.description}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* row 2 */}
        <div style={{ marginBottom: "40px", borderBottom: "1px solid #e0e0e0", paddingBottom: "40px" }}>
          <h1 style={getTitleStyle()}>Real-Time Inventory & Sales Tracking</h1>
          <p style={getSubtitleStyle()}>Manage your stock and inventory in real-time.</p>

          <Row
            gutter={[16, 24]}
            justify="center"
            style={{
              marginTop: "20px",
              padding: "0 10px",
            }}
          >
            {row2Features.map((feature) => (
              <Col span={getColumnSpan()} key={feature.title}>
                <Card
                  hoverable
                  style={getCardStyle()}
                >
                  <img
                    src={feature.image}
                    alt={feature.title}
                    style={getImageStyle()}
                  />
                  <Title level={screenSize === "mobile" ? 5 : 4}>{feature.title}</Title>
                  <Paragraph type="secondary" style={{ fontSize: screenSize === "mobile" ? "13px" : "14px" }}>
                    {feature.description}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* row 3 */}
        <div style={{ marginBottom: "30px", paddingBottom: "20px" }}>
          <h1 style={getTitleStyle()}>Fast & Easy Billing Tools</h1>
          <p style={getSubtitleStyle()}>Manage your shop's billing, products and categories in simple and easy steps.</p>

          <Row
            gutter={[16, 24]}
            justify="center"
            style={{
              marginTop: "20px",
              padding: "0 10px",
            }}
          >
            {row3Features.map((feature) => (
              <Col span={getColumnSpan()} key={feature.title}>
                <Card
                  hoverable
                  style={getCardStyle()}
                >
                  <img
                    src={feature.image}
                    alt={feature.title}
                    style={getImageStyle()}
                  />
                  <Title level={screenSize === "mobile" ? 5 : 4}>{feature.title}</Title>
                  <Paragraph type="secondary" style={{ fontSize: screenSize === "mobile" ? "13px" : "14px" }}>
                    {feature.description}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </>
  );
}

export default Features;